var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVra(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedVra0)",
    d: "M18.757 9.429c.072 0 .119.086.093.155l-.252.645a.1.1 0 0 1-.094.059h-.898a.1.1 0 0 0-.088.063l-.147.278c-.015.032.025.085.06.085h.793c.073 0 .12.089.094.152l-.263.635c-.017.034-.054.07-.094.07h-.898c-.04-.002-.093.008-.109.044l-2.768 6.332a.08.08 0 0 1-.078.053H9.957c-.04.002-.078-.029-.094-.065L7.521 12.16c-.03-.06.022-.16.088-.16h3.768c.037 0 .073.038.09.075l.533 1.21l2.505-5.077c.017-.035.055-.065.094-.065h3.762c.067 0 .117.09.088.15l-.534 1.074c-.015.032.011.062.047.062zm-6.21.797a.1.1 0 0 1-.09.06H5.628a.1.1 0 0 1-.091-.06l-.384-.633c-.027-.061.024-.163.091-.164h.795c.036 0 .06-.016.045-.05l-.46-1.094c-.028-.06.023-.141.09-.142h3.763a.1.1 0 0 1 .091.06l.502 1.189c.017.036.052.037.09.037h2.63c.072 0 .12.097.09.164zm-.724 1.28c-.016.036-.053.065-.092.065H6.24c-.039 0-.075-.03-.09-.065l-.395-.64c-.028-.061.024-.152.09-.152h6.205c.073 0 .121.085.092.152z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedVra0",
    x1: 6.401,
    x2: 14.631,
    y1: 10.431,
    y2: 19.032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82B1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#531685"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVra);
export default __webpack_public_path__ + "static/media/vra.ed9e5ef011f9a5d9beb396d89fb8e73f.svg";
export { ForwardRef as ReactComponent };